import React, { useEffect, useState } from "react";
import NavigationBar from "../NavigationBar";
import SideNavigation from "../SideNavigation";
import { Form, Col, Button, Alert } from 'react-bootstrap';
import "../../styles/css/Project.css";
import micro_reporter_api from "../../apis/micro-reporter-api";
import Utils from "../../libraries/utils";

const ProjectForm = (props) => {

  const [projectName, setProjectName] = useState('');
  const [projectDescription, setProjectDescription] = useState('');
  const [projectId,setProjectId] = useState(0);

    const [showProjectNameErrorMessage, setShowProjectNameErrorMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    let projectNameErrorMessage = "This project name is already in use!"
    let errorMessage = "An unexpected error was encountered!";

  const [projectTitle,setProjectTitle] = useState('New Project')
  useEffect(() => {
    isEditedProject();
  },[]);

  const isEditedProject = () => {

    (async () => {
      try{
        Utils.loadingScreen("show");
        let id = new URLSearchParams(window.location.search).get("id");
                if (id){
                    await micro_reporter_api.get(`/micro-reporter/project/find-by-id?id=` + id).then((response) => {
                        setProjectName(response.data.name);
                        setProjectDescription(response.data.description);
                        setProjectId(response.data.id);
                        setProjectTitle('Update Project');
                        Utils.loadingScreen("hide");
                    })
                }
      }catch (err){
          Utils.loadingScreen("hide");
      }finally{
        Utils.loadingScreen("hide");
      }
  	})();
	};

  const saveProject = () =>{
    let data = {
      "id" : projectId,
      "name": projectName,
      "description": projectDescription,
      "status" : true
    }

    let user = JSON.parse(localStorage.getItem("user"));
			(async () => {
			    try{
            Utils.loadingScreen("show");
            let headers = { "userId": user.id, "username": user.username, "relatedName": encodeURIComponent(data.name), "relatedId": data.id };
            if (data.id === 0) delete headers['relatedId'];
            let transaction = data.id === 0 ? "save":"update";
            const config = { headers };
            await micro_reporter_api.post('/micro-reporter/project/'+transaction, data, config).then(
                (response) => {
                    window.location.href = "/projects";
                    Utils.loadingScreen("hide");
                }
            );
        }catch (err) {
            Utils.loadingScreen("hide");
            try{
                showFailMessages(err.response);
            } catch (err){
                showError();
            }
        }
			})();
  };

    const showFailMessages = (response) => {
        switch(response.status) {
            case 406:
                showProjectNameError();
                break;
            default:
                showError();
        }
    };

    const showProjectNameError = () => {
        setShowProjectNameErrorMessage(true);
        setShowErrorMessage(false);
    }

    const showError = () => {
        setShowProjectNameErrorMessage(false);
        setShowErrorMessage(true);
    }

  return (
    <div>
      <SideNavigation current="projects" />
      <div className="page-order">
        <NavigationBar />
        <div id="project-form-page-div">
          <div>
            <h5 className="page-title" style={{ marginBottom: "40px" }}>{projectTitle}</h5>
          </div>
            {showErrorMessage ?
                (
                    <Alert variant="danger">
                        {errorMessage}
                    </Alert>
                ) : null
            }
            <Form noValidate id="connection-form">
              <Form.Row>
                <Form.Group as={Col} md="6" controlId="validationFormik01">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="projectName"
                    placeholder=""
                    onChange={(e) => setProjectName(e.target.value)}
                    value={projectName}
                    title={projectName}
                  />
                    {showProjectNameErrorMessage ?
                        (
                            <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{projectNameErrorMessage}</div>
                        ) : null
                    }
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} md="6" controlId="validationFormik01">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    type="text"
                    name="projectDescription"
                    placeholder=""
                    onChange={(e) => setProjectDescription(e.target.value)}
                    value={projectDescription}
                    title={projectDescription}
                  />
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} md="6">
                  <Button onClick={() => saveProject() } style={{ width: "170px", float: "right" }} >
                    Save
                  </Button>
                </Form.Group>
              </Form.Row>
            </Form>
            <div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectForm;
